<template>
    <!-- 备案规则 -->
    <div class="filing-rules flex justify-center">
        <div class="map" ref="mapRef"></div>
    </div>
</template>
<script setup lang="ts">
import chinaJson from './json/china.json'
import * as echarts from 'echarts'
const mapRef = ref()

interface Props {
    width?: number
    height?: number
}

// 省份ID信息
const seriesData = [
    {
        selected: true, //默认选中
        name: '北京市',
        value: 110000,
        id: 37
    },
    {
        name: '天津市',
        value: 120000,
        id: 38
    },
    {
        name: '河北省',
        value: 130000,
        id: 39
    },
    {
        name: '山西省',
        value: 140000,
        id: 40
    },
    {
        name: '内蒙古自治区',
        value: 150000,
        id: 41
    },
    {
        name: '辽宁省',
        value: 210000,
        id: 42
    },
    {
        name: '吉林省',
        value: 220000,
        id: 43
    },
    {
        name: '黑龙江省',
        value: 230000,
        id: 44
    },
    {
        name: '上海市',
        value: 310000,
        id: 45
    },
    {
        name: '江苏省',
        value: 320000,
        id: 46
    },
    {
        name: '浙江省',
        value: 330000,
        id: 47
    },
    {
        name: '安徽省',
        value: 340000,
        id: 48
    },
    {
        name: '福建省',
        value: 350000,
        id: 49
    },
    {
        name: '江西省',
        value: 360000,
        id: 50
    },
    {
        name: '山东省',
        value: 370000,
        id: 51
    },
    {
        name: '河南省',
        value: 410000,
        id: 52
    },
    {
        name: '湖北省',
        value: 420000,
        id: 53
    },
    {
        name: '湖南省',
        value: 430000,
        id: 54
    },
    {
        name: '广东省',
        value: 440000,
        id: 55
    },
    {
        name: '广西壮族自治区',
        value: 450000,
        id: 56
    },
    {
        name: '海南省',
        value: 460000,
        id: 57
    },
    {
        name: '重庆市',
        value: 500000,
        id: 58
    },
    {
        name: '四川省',
        value: 510000,
        id: 59
    },
    {
        name: '贵州省',
        value: 520000,
        id: 60
    },
    {
        name: '云南省',
        value: 530000,
        id: 61
    },
    {
        name: '西藏自治区',
        value: 540000,
        id: 62
    },
    {
        name: '陕西省',
        value: 610000,
        id: 63
    },
    {
        name: '甘肃省',
        value: 620000,
        id: 64
    },
    {
        name: '青海省',
        value: 630000,
        id: 65
    },
    {
        name: '宁夏回族自治区',
        value: 640000,
        id: 66
    },
    {
        name: '新疆维吾尔自治区',
        value: 650000,
        id: 67
    },
    {
        name: '台湾省',
        value: 710000,
        id: 68,
        label: {
            normal: {
                show: false, //显示省份标签
                textStyle: { color: '#000' } //省份标签字体颜色
            },
            emphasis: {
                //对应的鼠标悬浮效果
                show: false,
                textStyle: { color: '#323232' }
            }
        }
    },
    {
        name: '香港特别行政区',
        value: 810000,
        id: 69,
        label: {
            normal: {
                show: false, //显示省份标签
                textStyle: { color: '#000' } //省份标签字体颜色
            },
            emphasis: {
                //对应的鼠标悬浮效果
                show: false,
                textStyle: { color: '#323232' }
            }
        }
    },
    {
        name: '澳门特别行政区',
        value: 820000,
        label: {
            normal: {
                show: false, //显示省份标签
                textStyle: { color: '#000' } //省份标签字体颜色
            },
            emphasis: {
                //对应的鼠标悬浮效果
                show: false,
                textStyle: { color: '#323232' }
            }
        }
    },
    {
        name: '南海诸岛',
        value: 830000,
        label: {
            normal: {
                show: false, //显示省份标签
                textStyle: { color: '#000' } //省份标签字体颜色
            },
            emphasis: {
                //对应的鼠标悬浮效果
                show: false,
                textStyle: { color: '#323232' }
            }
        }
    }
]
// 图表配置
const option = {
    // backgroundColor: '#f0f0f0',
    series: [
        {
            name: '',
            type: 'map',
            mapType: 'china',
            roam: false, //是否开启鼠标缩放和平移漫游
            data: seriesData,
            // top: '3%', //组件距离容器的距离
            zoom: 1,
            selectedMode: 'single',
            label: {
                normal: {
                    show: true, //显示省份标签
                    textStyle: { color: '#000' } //省份标签字体颜色
                },
                emphasis: {
                    //对应的鼠标悬浮效果
                    show: true,
                    textStyle: { color: '#323232' }
                }
            },
            itemStyle: {
                normal: {
                    borderWidth: 0.5, //区域边框宽度
                    borderColor: '#10d0d4', //区域边框颜色
                    areaColor: '#ebf0f4' //区域颜色
                },

                emphasis: {
                    borderWidth: 0.5,
                    borderColor: '#4b0082',
                    areaColor: '#ece39e'
                }
            }
        }
    ]
}

onMounted(() => {
    initMap()
})

// 初始化地图
const initMap = () => {
    echarts.registerMap('china', chinaJson, {})
    const chinaChart = echarts.init(mapRef.value)
    chinaChart.setOption(option)
    chooseHandler(chinaChart)
}

const emit = defineEmits<{
    (e: 'clicks', name: string): void
}>()

// 选中省份处理
const chooseHandler = (chart: any) => {
    chart.on('click', (event: any) => {
        const { name, value, id } = event
        emit('clicks', event)
    })
}
</script>
<style lang="scss" scoped>
.map {
    width: 800px !important;
    height: 800px !important;
}
@media (max-width: 1200px) {
    .map {
        width: 700px !important;
        height: 700px !important;
    }
}
@media (max-width: 992px) {
    .map {
        width: 500px !important;
        height: 500px !important;
    }
}

@media (max-width: 768px) {
    .map {
        width: 600px !important;
        height: 600px !important;
    }
}

@media (max-width: 640px) {
    .map {
        width: 500px !important;
        height: 500px !important;
    }
}
@media (max-width: 540px) {
    .map {
        width: 400px !important;
        height: 400px !important;
    }
}
@media (max-width: 440px) {
    .map {
        width: 345px !important;
        height: 345px !important;
    }
}
</style>
